import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function UpdateProductModal({ product, onClose, onUpdateProduct }) {

    const [isUpdating, setIsUpdating] = useState(false);
    const [categories, setCategories] = useState([]); // Estado para armazenar as categorias

    const [formData, setFormData] = useState({
        id: product.id,
        nome: product.nome,
        valor: product.valor || '',
        descricao: product.descricao || '',
        quantidade: product.quantidade || '',
        categoria: product.categoria || '',
    });

    const [errorMessages, setErrorMessages] = useState({
        nome: '',
        valor: '',
        descricao: '',
        quantidade: '',
        categoria: '',
    });

    // Função para carregar as categorias
    const loadCategories = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/categoryRoutes/category`);
            setCategories(response.data);
        } catch (error) {
            console.error('Erro ao carregar as categorias', error);
        }

    };

    useEffect(() => {
        setFormData({
            id: product.id,
            nome: product.nome,
            valor: product.valor || '',
            valor_venda: product.valor_venda || '',
            descricao: product.descricao || '',
            quantidade: product.quantidade || '',
            categoria: product.categoria || '',
        });
        loadCategories();
    }, [product]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const validateForm = () => {
        let isValid = true;
        let newErrorMessages = {
            nome: '', valor: '', descricao: '', quantidade: '', categoria: '', valor_venda: ''
        };

        // Validação do nome
        if (!formData.nome.trim()) {
            newErrorMessages.nome = 'O nome do produto é obrigatório.';
            isValid = false;
        }

        // Validação do valor
        if (!formData.valor.trim()) {
            newErrorMessages.valor = 'O valor é obrigatório.';
            isValid = false;
        } else if (isNaN(formData.valor) || formData.valor <= 0) {
            newErrorMessages.valor = 'O valor deve ser um número válido e maior que 0.';
            isValid = false;
        }

        if (!formData.valor_venda.trim()) {
            newErrorMessages.valor = 'O valor de venda é obrigatório.';
            isValid = false;
        } else if (isNaN(formData.valor_venda) || formData.valor_venda <= 0) {
            newErrorMessages.valor_venda = 'O valor de venda deve ser um número válido e maior que 0.';
            isValid = false;
        }

        // Validação da quantidade
        if (!formData.quantidade) {
            newErrorMessages.quantidade = 'A quantidade é obrigatória.';
            isValid = false;
        } else if (isNaN(formData.quantidade) || formData.quantidade < 0 || !Number.isInteger(Number(formData.quantidade))) {
            newErrorMessages.quantidade = 'A quantidade deve ser um número inteiro válido e maior ou igual a 0.';
            isValid = false;
        }

        // Validação da categoria
        if (!formData.categoria.trim()) {
            newErrorMessages.categoria = 'A categoria é obrigatória.';
            isValid = false;
        }

        setErrorMessages(newErrorMessages);
        return isValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            // try {
                // Atualiza os dados do produto
                const updatedProduct = {
                    ...formData,
                    nome: formData.nome.trim().replace(/\b\w/g, char => char.toUpperCase()),
                };

                onUpdateProduct(updatedProduct);
                onClose();

            //     const response = await axios.put(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/productRoutes/product/${formData.id}`, updatedProduct, {
            //         headers: {
            //             'Content-Type': 'application/json',
            //         },
            //     });
            //
            //     if (response.status === 200) {
            //         onUpdateProduct(updatedProduct);
            //         onClose();
            //     } else {
            //         alert('Ocorreu um erro ao tentar atualizar o produto.');
            //     }
            // } catch (error) {
            //     console.error('Erro ao atualizar produto:', error);
            //     alert('Não foi possível atualizar o produto. Tente novamente mais tarde.');
            // }finally {
            //     setIsUpdating(false);
            // }
        }
    };

    return (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex justify-center items-center z-50">
            <div className="glass-panel p-6 w-full max-w-2xl text-white w-96">
                <h2 className="text-xl font-bold text-white mb-6 tracking-wide">Atualizar Produto</h2>
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-200">Nome</label>
                        <input
                            type="text"
                            name="nome"
                            value={formData.nome}
                            onChange={handleChange}
                            className={`glass-input w-full ${errorMessages.nome ? 'border-red-500' : ''}`}
                        />
                        {errorMessages.nome && (
                            <p className="text-red-500 text-sm mt-1">{errorMessages.nome}</p>
                        )}
                    </div>

                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-200">Valor</label>
                        <input
                            type="float"
                            name="valor"
                            value={formData.valor}
                            onChange={handleChange}
                            min="0"
                            className={`glass-input w-full ${errorMessages.valor ? 'border-red-500' : ''}`}
                        />
                        {errorMessages.valor && (
                            <p className="text-red-500 text-sm mt-1">{errorMessages.valor}</p>
                        )}
                    </div>

                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-200">Valor de Venda</label>
                        <input
                            type="float"
                            name="valor_venda"
                            value={formData.valor_venda}
                            onChange={handleChange}
                            min="0"
                            className={`glass-input w-full ${errorMessages.valor_venda ? 'border-red-500' : ''}`}
                        />
                        {errorMessages.valor_venda && (
                            <p className="text-red-500 text-sm mt-1">{errorMessages.valor_venda}</p>
                        )}
                    </div>

                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-200">Quantidade</label>
                        <input
                            type="number"
                            name="quantidade"
                            value={formData.quantidade}
                            onChange={handleChange}
                            min="0"
                            className={`glass-input w-full ${errorMessages.quantidade ? 'border-red-500' : ''}`}
                        />
                        {errorMessages.quantidade && (
                            <p className="text-red-500 text-sm mt-1">{errorMessages.quantidade}</p>
                        )}
                    </div>

                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-200">Categoria</label>
                        <select
                            name="categoria"
                            value={formData.categoria}
                            onChange={handleChange}
                            className={`glass-input w-full ${errorMessages.categoria ? 'border-red-500' : ''}`}
                        >
                            <option value="">Selecione uma categoria</option>
                            {categories.map((category) => (
                                <option key={category.id} value={category.nome}>
                                    {category.nome}
                                </option>
                            ))}
                        </select>
                        {errorMessages.categoria && (
                            <p className="text-red-500 text-sm mt-1">{errorMessages.categoria}</p>
                        )}
                    </div>

                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-200">Descrição</label>
                        <textarea
                            name="descricao"
                            value={formData.descricao}
                            onChange={handleChange}
                            className={`glass-input w-full ${errorMessages.descricao ? 'border-red-500' : ''}`}
                        />
                        {errorMessages.descricao && (
                            <p className="text-red-500 text-sm mt-1">{errorMessages.descricao}</p>
                        )}
                    </div>

                    <div className="flex justify-end space-x-2">
                        <button
                            type="button"
                            onClick={onClose}
                            className="bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600"
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
                        >
                            Atualizar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
